import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, retry, timeout } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  IApiReservation,
  IBookingRequest,
  IBulkDisponibilityRequest,
  ICreateDisponibilityRequest,
  IDispoResponse,
  IUpdateAppointmentRequest,
  IUpdateDisponibilityRequest,
  IUserReservation
} from '../../interfaces/reservation.interface';

@Injectable({
  providedIn: 'root'
})
export class ReservationApiService {
  #http: HttpClient = inject(HttpClient);
  #apiBaseUrl: string = environment.apiUrl;

  getUserReservations(): Observable<IUserReservation[]> {
    return this.#http.get<IUserReservation[]>(`${this.#apiBaseUrl}/tools/reservation`);
  }

  createReservation(bookingData: IBookingRequest): Observable<IUserReservation> {
    return this.#http.post<IUserReservation>(`${this.#apiBaseUrl}/tools/reservation`, bookingData);
  }

  getHairdresserReservations(): Observable<IApiReservation[]> {
    return this.#http.get<IApiReservation[]>(`${this.#apiBaseUrl}/tools/reservation`);
  }

  getDisponibilities(hairdresserId: number): Observable<IDispoResponse[]> {
    return this.#http.get<IDispoResponse[]>(`${this.#apiBaseUrl}/tools/dispo?id=${hairdresserId}`).pipe(
      timeout(10000), // 10 secondes de timeout
      retry(1) // Retry une fois en cas d'échec
    );
  }

  postDisponibility(disponibility: ICreateDisponibilityRequest): Observable<any> {
    return this.#http.post(`${this.#apiBaseUrl}/tools/dispo`, disponibility);
  }

  addBulkDisponibilities(disponibilities: IBulkDisponibilityRequest): Observable<any> {
    return this.#http.post(`${this.#apiBaseUrl}/tools/dispo`, disponibilities);
  }

  updateDisponibility(disponibility: IUpdateDisponibilityRequest): Observable<any> {
    return this.#http.put(`${this.#apiBaseUrl}/tools/dispo`, disponibility);
  }

  deleteDisponibility(id: number): Observable<any> {
    return this.#http.delete(`${this.#apiBaseUrl}/tools/dispo?id=${id}`);
  }

  getTodayReservations(hairdresserId: number, date?: string): Observable<IUserReservation[]> {
    const targetDate = date || new Date().toISOString().split('T')[0];
    const params = `?hairdresserId=${hairdresserId}&date=${targetDate}`;
    return this.#http.get<IUserReservation[]>(`${this.#apiBaseUrl}/tools/reservation/today${params}`);
  }

  acceptReservation(reservationId: number): Observable<any> {
    return this.#http.put(`${this.#apiBaseUrl}/reservation/valid?id=${reservationId}`, {});
  }

  rejectReservation(reservationId: number): Observable<any> {
    return this.#http.put(`${this.#apiBaseUrl}/reservation/reject?id=${reservationId}`, {});
  }

  updateAppointment(updateData: IUpdateAppointmentRequest): Observable<any> {
    return this.#http.put(`${this.#apiBaseUrl}/reservation/update-apointment`, updateData);
  }

  valideUpdateAppointment(updateData: any): Observable<any> {
    return this.#http.put(`${this.#apiBaseUrl}/reservation/update-apointment`, updateData);
  }

  cancelReservation(reservationId: number): Observable<any> {
    return this.#http.put(`${this.#apiBaseUrl}/reservation/cancel?id=${reservationId}`, {});
  }

  finishReservation(reservationId: number): Observable<any> {
    return this.#http.put(`${this.#apiBaseUrl}/reservation/finish?id=${reservationId}`, {});
  }
}

